import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index/Index.vue'
import ENV from './api/env.js'
import checkLogin from './utils/checkLogin'
Vue.use(Router);

const routes = [
    // {
    //     path: '*',
    //     redirect: '/artedusharing',
    // },
    {
        path: '/',
        //redirect: '/index',
        component: Index,
    },
    {
        name: 'index',
        component: Index,
        meta: {
            title: '全民终身学习艺术教育资源共享平台'
        },
        path: "/index"
    },
    {
        path: '/companyList',
        name: 'companyList',
        meta: {
            title: '单位列表'
        },
        component: () => import( './views/company/CompanyList.vue')
    },
    {
        path: '/companyDetail',
        name: 'companyDetail',
        meta: {
            title: '单位详情'
        },
        component: () => import( './views/company/CompanyDetail.vue')
    },
    {
        path: '/newsActivityList',
        name: 'newsActivityList',
        meta: {
            title: '新闻·活动'
        },
        component: () => import( './views/newsActivity/NewsActivityList.vue')
    },
    {
        path: '/newsActivityDetail',
        name: 'newsActivityDetail',
        meta: {
            title: '新闻活动详情'
        },
        component: () => import( './views/newsActivity/NewsActivityDetail.vue')
    },
    {
        path: '/expertTeacherList',
        name: 'expertTeacherList',
        meta: {
            title: '教师列表'
        },
        component: () => import( './views/expertTeacher/ExpertTeacherList.vue')
    },
    {
        path: '/expertTeacherDetail',
        name: 'expertTeacherDetail',
        meta: {
            title: '详情'
        },
        component: () => import( './views/expertTeacher/ExpertTeacherDetail.vue')
    },
    {
        path: '/scoreDetail',
        name: 'scoreDetail',
        meta: {
            title: '成绩详情'
        },
        component: () => import( './views/ScoreDetail.vue')
    },
    {
        path: '/catalogList',
        name: 'catalogList',
        meta: {
            title: '社区教育规范化活动目录'
        },
        component: () => import( './views/catalog/CatalogLists.vue')
    },
    {
        path: '/collectDetail',
        name: 'collectDetail',
        meta: {
            title: '参与征集'
        },
        component: () => import( './views/catalog/CollectDetail.vue')
    },
    {
        path: '/instStudioList',
        name: 'instStudioList',
        meta: {
            title: '美育地图：艺术教育资源共享', //社区艺术培训机构&社区教育指导中心
        },
        component: () => import( './views/instStudio/InstStudioList.vue')
    },
    {
        path: '/instDetail',
        name: 'instDetail',
        meta: {
            title: '机构详情'
        },
        component: () => import( './views/instStudio/InstDetail.vue')
    },
    {
        path: '/studioDetail',
        name: 'studioDetail',
        meta: {
            title: '工作室详情'
        },
        component: () => import( './views/instStudio/StudioDetail.vue')
    },
    {
        path: '/certList',
        name: 'certList',
        title: '个人证书及报告查询',
        component: () => import( './views/certList/Index.vue')
    },
    {
        path: '/applyClassroom',
        name: 'applyClassroom',
        title: '申请成为社区教育规范教学实验室',
        component: () => import( './views/apply/ApplyClassroom.vue')
    },
    {
        path: '/applyJoinTalentPool',
        name: 'applyJoinTalentPool',
        title: '申请加入社区艺术教育教师人才库',
        component: () => import( './views/apply/ApplyJoinTalentPool.vue')
    },
    //新证书
    {
        path: '/certifacate',
        name: 'certifacate',
        title: '个人证书及测评报告',
        component: () => import( './views/certifacate/CertDetail.vue')
    },
    // //登录回调页面
    // {
    //     path: '/callback.html',
    //     name: 'loginCallback',
    //     title: '登录回调页面',
    //     component: () => import( './views/index/loginCallback.vue')
    // },
    //个人中心页面
    //个人中心
    {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import( './views/my/PersonalCenter.vue'),
        meta: {
            title: '个人中心',
            needLogin:true
        },
    },
    //编辑个人信息
    {
        path: '/editUserInfo',
        name: 'editUserInfo',
        component: () => import( './views/my/EditUserInfo.vue'),
        meta: {
            title: '个人中心',
            needLogin:true
        },
    },
    //实名认证
    {
        path: '/realInfo',
        name: 'realInfo',
        component: () => import( './views/my/realInfo.vue'),
        meta: {
            title: '实名认证',
            needLogin:true
        },
    },

    //登录回调页面
    {
        path: '/callback.html',
        name: 'loginCallback',
        component: () => import( './views/index/loginCallback.vue'),
        meta: {
            title: '登录回调页面'
        },
    },
];

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + route.type + '/' + (route.name || '');
});

const router = new Router({
    mode: 'history',
    base: ENV===1 ? '/artedusharing/' : process.env.BASE_URL,
    routes: routes
});


router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        var userInfo = localStorage.getItem('userInfo');
        if(userInfo){
            next()
        }
        else{
            checkLogin.checkLogin('login');
        }
    }
    else {
        next();
    }
});

export {
    router,
};